import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Core2Config } from '../../shared/core2Config';
import { StockReplenishmentEventFilterLocationModel } from '../../../../../../models/aggregates/erp/stock/stock-replenishment-event-filter-location.model';
import { BaseApiTemplateService } from '../../shared';


@Injectable({ providedIn: 'root' })
export class StockReplenishmentEventFilterLocationService extends BaseApiTemplateService<StockReplenishmentEventFilterLocationModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/stock-replenishment-event-filter-locations/backoffice-ep';

  constructor(theHttp: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/stock-replenishment-event-filter-locations/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/stock-replenishment-event-filter-locations/backoffice-ep';
    this.httpClient = theHttp;
  }

}
